import * as React from 'react';
import { IAccountBlockViewProps } from './account-block';
import { renderAccountBlock } from './utilities';

export default (props: IAccountBlockViewProps) => {
    return <div className='hei-account-block'>{renderAccountBlock(props, false)}</div>;
};
